'use strict'

define ['./notifications.css'], () ->
  ($q, $scope, $http, RentappService, RENTAPPLICATION_API_URL, $state, Flash, Landlord, $window) ->
    $scope.emails = []
    Landlord.getMe().$promise.then (response) ->
      $scope.landlord = response
      if $scope.landlord.landlord_emails
        _.map($scope.landlord.landlord_emails.split('\n'), (email) ->
          $scope.emails.push({text: email})
        )

    $scope.update_notifications = (notification_settings) ->
      $scope.updating_preference = true
      promises = []
      landlord_emails = (email.text for email in $scope.emails).join '\n'
        
      promises.push($http.put "#{RENTAPPLICATION_API_URL}#{notification_settings.resource_uri}", notification_settings)
      promises.push($http.patch "#{RENTAPPLICATION_API_URL}#{$scope.landlord.resource_uri}", {landlord_emails: landlord_emails, contact_phone: $scope.landlord.contact_phone})
      
      $q.all(promises)
        .then () ->
          $scope.updating_preference = false
          Flash.clear()
          Flash.create('success', 'Notification Preferences successfully updated.', 3000, {class: 'profile-success'}, true)
          $window.scrollTo(0, 0);
        .catch (error) ->
          Flash.clear()
          Flash.create('danger',  "Something went wrong.", 3000)
          # TODO: Need to handle update error
          console.log(error)
          $window.scrollTo(0, 0);
        .finally ->
          $scope.updating_preference = false


// WEBPACK FOOTER //
// ./components/dashboard/settings/notifications/notifications.coffee